import React from 'react';
import Header from '../../components/Header/index';
import Footer from '../../components/Footer';
//import FooterTwo from '../../components/Footer/FooterTwo';
import Breadcrumb from '../../components/Breadcrumb';
import ScrollToTop from '../../components/ScrollTop';
import AboutMain from './AboutMain';

import Logo from '../../assets/images/logos/logo2.png';

import urls from '../../constants/urls.js';

const AboutUs = ( {sendDataToParent, sendPageToIndex} ) => {
    return (
        <>
            <Header
                parentMenu='home'
                topbarEnable='enable'
                sendDataToParent={sendDataToParent}
                sendPageToIndex={sendPageToIndex}

            />

            <AboutUsEXT />

            {/***<AllSchoolsEXT />***/}

            <Footer
                footerLogo='https://www.bfatechnologies.tech/images/assets/images/logos/footer-logo.png'
            />
        </>
    );
}

const AboutUsEXT = ({sendDataToParent, sendPageToIndex} ) => {

    return (
        <>
           {/*** *
            <div class="react-wrapper">
                <div class="react-wrapper-inner">
                   
                    
                    <Breadcrumb pageTitle="About Us" />
                    ***/}

                    <AboutMain />

                    {/* scrolltop-start 
                    <ScrollToTop />
                     scrolltop-end 
                </div>
            </div>
             */}
            {/***<FooterTwo />***/}

        </>
    );
}

export default AboutUs;